var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4px",
    height: "16px",
    viewBox: "0 0 4 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edit Vertical Dot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-10.000000, -3.500000)",
    fill: "#0375BA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(10.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.896,3.336 C2.808,3.336 3.576,2.568 3.576,1.68 C3.576,0.768 2.808,-1.08357767e-13 1.896,-1.08357767e-13 C0.984,-1.08357767e-13 0.24,0.768 0.24,1.68 C0.24,2.568 0.984,3.336 1.896,3.336 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.776,9.336 C2.688,9.336 3.456,8.568 3.456,7.68 C3.456,6.768 2.688,6 1.776,6 C0.864,6 0.12,6.768 0.12,7.68 C0.12,8.568 0.864,9.336 1.776,9.336 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.656,15.336 C2.568,15.336 3.336,14.568 3.336,13.68 C3.336,12.768 2.568,12 1.656,12 C0.744,12 -3.3462122e-13,12.768 -3.3462122e-13,13.68 C-3.3462122e-13,14.568 0.744,15.336 1.656,15.336 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a8f7084433c754810acea90399179282.svg";
export { ForwardRef as ReactComponent };